module.exports = __webpack_public_path__ + "static/media/course_1.7fbc4fda.jpg";